export default __webpack_public_path__ + "static/media/Ballroll_00168.6abd0e9f.png";